import config from '../../../config';

const _SZ = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  0.08,
  8,
  0.12,
  9,
  0.18,
  10,
  0.26,
  11,
  0.35,
  13,
  0.45,
];
const _SZ_LG = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  0.13,
  8,
  0.19,
  9,
  0.29,
  10,
  0.42,
  11,
  0.56,
  13,
  0.72,
];

function _ov(id, filter, size = _SZ) {
  return {
    id,
    type: 'symbol',
    source: 'map',
    'source-layer': 'overlays',
    minzoom: 7,
    filter,
    layout: {
      'icon-image': ['get', 'image'],
      'icon-size': size,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
    },
  };
}

function _overlayLayers() {
  return [
    _ov(
      'overlays-companies',
      ['==', ['slice', ['get', 'image'], 0, 8], 'company:'],
      _SZ_LG
    ),
    _ov('overlays-fuel', ['==', ['get', 'image'], 'service:map_gas_ico']),
    _ov('overlays-garage', [
      '==',
      ['get', 'image'],
      'service:map_garage_large_ico',
    ]),
    _ov('overlays-repair', ['==', ['get', 'image'], 'service:map_service_ico']),
    _ov('overlays-recruitment', [
      '==',
      ['get', 'image'],
      'service:map_recruitment_ico',
    ]),
    _ov('overlays-dealer', ['==', ['get', 'image'], 'service:map_dealer_ico']),
    _ov('overlays-border', ['==', ['get', 'image'], 'road:road_border_ico']),
    _ov('overlays-toll', ['==', ['get', 'image'], 'road:road_toll_ico']),
    _ov('overlays-busstop', ['==', ['get', 'image'], 'misc:busstop_bus_stop']),
    _ov('overlays-road', [
      'all',
      ['==', ['slice', ['get', 'image'], 0, 5], 'road:'],
      ['!=', ['get', 'image'], 'road:road_border_ico'],
      ['!=', ['get', 'image'], 'road:road_toll_ico'],
    ]),
    _ov('overlays-misc', [
      'all',
      ['!=', ['slice', ['get', 'image'], 0, 8], 'company:'],
      ['!=', ['slice', ['get', 'image'], 0, 5], 'road:'],
      ['!=', ['get', 'image'], 'service:map_gas_ico'],
      ['!=', ['get', 'image'], 'service:map_garage_large_ico'],
      ['!=', ['get', 'image'], 'service:map_service_ico'],
      ['!=', ['get', 'image'], 'service:map_recruitment_ico'],
      ['!=', ['get', 'image'], 'service:map_dealer_ico'],
      ['!=', ['get', 'image'], 'misc:busstop_bus_stop'],
    ]),
  ];
}

export const OVERLAY_LAYER_GROUPS = [
  { id: 'players', label: 'Live Players' },
  { id: 'overlays-companies', label: 'Companies' },
  { id: 'overlays-fuel', label: 'Fuel Stations' },
  { id: 'overlays-garage', label: 'Garages' },
  { id: 'overlays-repair', label: 'Service Stations' },
  { id: 'overlays-recruitment', label: 'Recruitment' },
  { id: 'overlays-dealer', label: 'Truck Dealers' },
  { id: 'overlays-toll', label: 'Tollgates' },
  { id: 'overlays-busstop', label: 'Bus Stops' },
  { id: 'overlays-road', label: 'Road Names' },
  { id: 'overlays-misc', label: 'Other' },
  {
    id: 'city-labels',
    label: 'City Names',
    groups: ['city-labels-large', 'city-labels-medium', 'city-labels-small'],
  },
  { id: 'country-labels', label: 'Country Names' },
  {
    id: 'all-buildings',
    label: 'Buildings',
    groups: ['buildings', 'map-buildings', 'prefab-buildings', 'buildings'],
  },
  {
    id: 'footprints',
    label: 'Building Footprints',
  },
  {
    id: 'footprints-roads',
    label: 'Road Footprints',
    groups: ['hidden-roads', 'hidden-prefabs'],
  },
];

const _ROAD_COLOR = (appSettings) => [
  'match',
  ['get', 'road_class'],
  'highway',
  appSettings?.liveMap?.highwayColor || '#D4A017',
  /* normal/local */ appSettings?.liveMap?.secondaryRoadsColor || '#8A9BAD',
];

const _SECRET_ROAD_WIDTH = [
  'interpolate',
  ['linear'],
  ['zoom'],
  6,
  ['case', ['==', ['get', 'road_class'], 'highway'], 1.2, 0.8],
  10,
  ['case', ['==', ['get', 'road_class'], 'highway'], 2.8, 1.8],
  14,
  ['case', ['==', ['get', 'road_class'], 'highway'], 5.5, 3.5],
];

function buildBackground(baseUrl, game, mapInfo) {
  if (!mapInfo?.texture_bbox_wgs84) {
    return { sources: {}, layers: [] };
  }

  return {
    sources: {
      'game-background': {
        type: 'raster',
        url: `pmtiles://${baseUrl}/pmtiles/${game}-background.pmtiles`,
        tileSize: 256,
      },
    },
    layers: [
      {
        id: 'game-background',
        type: 'raster',
        source: 'game-background',
        paint: { 'raster-opacity': 0.85 },
      },
    ],
  };
}

export function createMapStyle(game, tileMapInfo, appSettings = null) {

  const version = tileMapInfo.version || '1';

  const rawBase =
    config.VECTOR_LIVE_MAP_DATA_BASE_URL || 'http://localhost:8888';
  const baseUrl = rawBase.startsWith('http')
    ? rawBase
    : `${window.location.origin}${rawBase}`;
  const sprite = [
    {
      id: 'company',
      url: `${baseUrl}/${game}/sprites/sprite-company?v=${version}`,
    },
    {
      id: 'service',
      url: `${baseUrl}/${game}/sprites/sprite-service?v=${version}`,
    },
    {
      id: 'road',
      url: `${baseUrl}/${game}/sprites/sprite-road?v=${version}`,
    },
    {
      id: 'misc',
      url: `${baseUrl}/${game}/sprites/sprite-misc?v=${version}`,
    },
  ];

  console.log('Using map style with base URL:', baseUrl);
  return {
    version: 8,
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
    attributionControl: false,
    sprite,
    sources: {
      map: {
        type: 'vector',
        url: `pmtiles://${baseUrl}/pmtiles/${game}.pmtiles?v=${version}`,
      },
      'footprints-source': {
        type: 'vector',
        url: `pmtiles://${baseUrl}/pmtiles/${game}-footprints.pmtiles?v=${version}`,
      },
      //...background.sources,
      players: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      route: {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
      },
      markers: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
    },
    layers: [
      {
        id: 'hidden-prefabs',
        type: 'line',
        source: 'footprints-source',
        'source-layer': 'hidden_prefabs',
        minzoom: 6,
        paint: {
          'line-color': '#4a5e70',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            0.4,
            10,
            1.2,
            14,
            2.5,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 8, 0.8],
        },
      },
      {
        id: 'hidden-roads',
        type: 'line',
        source: 'footprints-source',
        'source-layer': 'hidden_roads',
        minzoom: 6,
        paint: {
          'line-color': '#4a5e70',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            0.4,
            10,
            1.2,
            14,
            2.5,
          ],
          'line-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 8, 0.8],
        },
      },
      {
        id: 'prefab-flat',
        type: 'fill',
        source: 'map',
        'source-layer': 'prefab_flat',
        minzoom: 6,
        paint: {
          'fill-color': ['get', 'color'],
          'fill-opacity': 0.4,
        },
      },
      {
        id: 'map-flat',
        type: 'fill',
        source: 'map',
        'source-layer': 'map_flat',
        minzoom: 6,
        paint: {
          'fill-color': ['get', 'color'],
          'fill-opacity': 0.4,
        },
      },
      {
        id: 'roads',
        type: 'fill',
        source: 'map',
        'source-layer': 'roads',
        filter: ['!=', ['get', 'is_secret'], true],
        paint: {
          'fill-color': _ROAD_COLOR(appSettings),
          'fill-opacity': 1.0,
          'fill-antialias': true,
        },
      },
      {
        id: 'roads-secret',
        type: 'line',
        source: 'map',
        'source-layer': 'roads',
        filter: ['==', ['get', 'is_secret'], true],
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        paint: {
          'line-color': _ROAD_COLOR(appSettings),
          'line-width': _SECRET_ROAD_WIDTH,
          'line-opacity': 1.0,
          'line-dasharray': [1.2, 2.4],
        },
      },
      {
        id: 'prefab_roads',
        type: 'fill',
        source: 'map',
        'source-layer': 'prefab_roads',
        filter: ['!=', ['get', 'is_secret'], true],
        paint: {
          'fill-color': _ROAD_COLOR(appSettings),
          'fill-opacity': 1.0,
          'fill-antialias': true,
        },
      },
      {
        id: 'prefab-roads-secret',
        type: 'line',
        source: 'map',
        'source-layer': 'prefab_roads',
        filter: ['==', ['get', 'is_secret'], true],
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        paint: {
          'line-color': _ROAD_COLOR(appSettings),
          'line-width': _SECRET_ROAD_WIDTH,
          'line-opacity': 1.0,
          'line-dasharray': [1.2, 2.4],
        },
      },
      {
        id: 'ferries',
        type: 'line',
        source: 'map',
        'source-layer': 'ferries',
        paint: {
          'line-color': '#4D7EA8',
          'line-width': [
            'interpolate',
            ['linear'],
            ['zoom'],
            4,
            1,
            6,
            2,
            8,
            3,
            10,
            4,
          ],
          'line-dasharray': [1, 2],
        },
      },
      {
        id: 'ferry-labels',
        type: 'symbol',
        source: 'map',
        'source-layer': 'ferries',
        minzoom: 7,
        filter: ['all', ['==', '$type', 'LineString'], ['has', 'label']],
        layout: {
          'symbol-placement': 'line-center',
          'text-field': ['get', 'label'],
          'text-font': ['Klokantech Noto Sans Regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            5,
            10,
            8,
            12,
            11,
            14,
          ],
          'text-rotation-alignment': 'map',
          'text-pitch-alignment': 'viewport',
          'text-keep-upright': true,
          'text-anchor': 'center',
          'text-offset': [0, -0.7],
          'text-allow-overlap': false,
          'text-ignore-placement': false,
          'text-padding': 4,
        },
        paint: {
          'text-color': '#C8E8FF',
          'text-halo-color': '#10202E',
          'text-halo-width': 2,
          'text-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            5,
            0.75,
            7,
            0.95,
          ],
        },
      },
      {
        id: 'footprints',
        type: 'fill-extrusion',
        source: 'footprints-source',
        'source-layer': 'footprints',
        minzoom: 6,
        paint: {
          'fill-extrusion-color': '#1e2a35',
          // Game height units (meters) need ~20x scale to match other building layers in the viewer
          'fill-extrusion-height': [
            '*',
            20,
            ['coalesce', ['get', 'height'], 8],
          ],
          'fill-extrusion-base': 0,
          'fill-extrusion-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            0.25,
            7,
            0.35,
            8,
            0.45,
          ],
          'fill-extrusion-vertical-gradient': false,
        },
      },
      {
        id: 'prefab-buildings',
        type: 'fill-extrusion',
        source: 'map',
        'source-layer': 'prefab_buildings',
        minzoom: 7,
        paint: {
          'fill-extrusion-color': '#2A3645',
          'fill-extrusion-height': [
            '-',
            ['coalesce', ['get', 'height'], 400],
            ['coalesce', ['get', 'elevation'], 0],
          ],
          'fill-extrusion-base': 0,
          'fill-extrusion-opacity': 0.55,
          'fill-extrusion-vertical-gradient': false,
        },
      },
      {
        id: 'map-buildings',
        type: 'fill-extrusion',
        source: 'map',
        'source-layer': 'map_buildings',
        minzoom: 7,
        paint: {
          'fill-extrusion-color': '#2E3E50',
          'fill-extrusion-height': [
            '-',
            ['coalesce', ['get', 'height'], 400],
            ['coalesce', ['get', 'elevation'], 0],
          ],
          'fill-extrusion-base': 0,
          'fill-extrusion-opacity': 0.55,
          'fill-extrusion-vertical-gradient': false,
        },
      },
      {
        id: 'buildings',
        type: 'fill-extrusion',
        source: 'map',
        'source-layer': 'buildings',
        minzoom: 7,
        paint: {
          'fill-extrusion-color': '#354755',
          'fill-extrusion-height': ['coalesce', ['get', 'height'], 500],
          'fill-extrusion-base': ['coalesce', ['get', 'elevation'], 0],
          'fill-extrusion-opacity': 0.55,
          'fill-extrusion-vertical-gradient': false,
        },
      },
      // "buildings" layer (TsBuildingItem procedural segments) intentionally omitted —
      // they appear as thin diagonal strips that are not useful for visualization.

      ..._overlayLayers(),
      {
        id: 'country-labels',
        type: 'symbol',
        source: 'map',
        'source-layer': 'countries',
        minzoom: 3,
        maxzoom: 5,
        layout: {
          'text-field': ['get', 'name'],
          'text-font': ['Klokantech Noto Sans Bold'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            11,
            4,
            13,
            5,
            16,
            6,
            18,
          ],
          'text-anchor': 'center',
          'text-allow-overlap': true,
          'text-ignore-placement': true,
          'text-letter-spacing': 0.15,
        },
        paint: {
          'text-color': '#FFFFFF',
          'text-halo-color': '#0F1C26',
          'text-halo-width': 2,
          'text-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            3,
            0.6,
            4,
            0.8,
            4.75,
            1,
            5,
            0,
          ],
        },
      },
      // ── City labels – population tiers ────────────────────────────────────
      // Countries disappear at zoom 5 → cities start appearing from zoom 5 onward
      //
      // Large  (population ≥ 500 000): zoom 5 → 5.75
      // Medium (100 000 – 499 999, or unknown default 150 000): zoom 6 → 7
      // Small  (< 100 000): zoom 7.5 → 8.5
      {
        id: 'city-labels-large',
        type: 'symbol',
        source: 'map',
        'source-layer': 'cities',
        minzoom: 5,
        filter: ['>=', ['coalesce', ['get', 'population'], 0], 500000],
        layout: {
          'text-field': ['get', 'localized_name'],
          'text-font': ['Klokantech Noto Sans Regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            5,
            13,
            6,
            16,
            8,
            20,
            10,
            24,
          ],
          'text-anchor': 'top',
          'text-offset': [0, 0.8],
          'text-allow-overlap': true,
          'text-ignore-placement': true,
        },
        paint: {
          'text-color': '#FFFFFF',
          'text-halo-color': '#0B1822',
          'text-halo-width': 2.5,
          'text-opacity': ['interpolate', ['linear'], ['zoom'], 5, 0, 5.75, 1],
        },
      },
      // Medium cities (100 000 ≤ population < 500 000, or unknown): zoom 6
      {
        id: 'city-labels-medium',
        type: 'symbol',
        source: 'map',
        'source-layer': 'cities',
        minzoom: 6,
        filter: [
          'all',
          ['>=', ['coalesce', ['get', 'population'], 150000], 100000],
          ['<', ['coalesce', ['get', 'population'], 150000], 500000],
        ],
        layout: {
          'text-field': ['get', 'localized_name'],
          'text-font': ['Klokantech Noto Sans Regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            6,
            11,
            8,
            14,
            10,
            18,
          ],
          'text-anchor': 'top',
          'text-offset': [0, 0.8],
          'text-allow-overlap': true,
          'text-ignore-placement': true,
        },
        paint: {
          'text-color': '#EEF4FF',
          'text-halo-color': '#0B1822',
          'text-halo-width': 2.5,
          'text-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0, 7, 1],
        },
      },
      // Small cities (population < 100 000): zoom 7.5
      {
        id: 'city-labels-small',
        type: 'symbol',
        source: 'map',
        'source-layer': 'cities',
        minzoom: 7.5,
        filter: ['<', ['coalesce', ['get', 'population'], 150000], 100000],
        layout: {
          'text-field': ['get', 'localized_name'],
          'text-font': ['Klokantech Noto Sans Regular'],
          'text-size': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8,
            10,
            10,
            12,
            12,
            15,
          ],
          'text-anchor': 'top',
          'text-offset': [0, 0.8],
          'text-allow-overlap': true,
          'text-ignore-placement': true,
        },
        paint: {
          'text-color': '#FFFFFF',
          'text-halo-color': '#0B1822',
          'text-halo-width': 2.5,
          'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 8, 1],
        },
      },
      // ── Live player markers ─────────────────────────────────────────────────
      {
        id: 'players',
        type: 'circle',
        source: 'players',
        filter: ['!=', ['get', 'followed'], true],
        paint: {
          'circle-radius': parseInt(
            appSettings?.liveMap?.playerMarkerSizeVectorMap ?? 5,
            10
          ),
          'circle-color': ['get', 'color'],
          'circle-stroke-width': 1,
          'circle-stroke-color': '#ffffff',
        },
        minzoom: 5,
      },
      {
        id: 'players-followed',
        type: 'symbol',
        source: 'players',
        filter: ['==', ['get', 'followed'], true],
        layout: {
          'icon-image': 'player-follow-arrow',
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.13, 10, 0.19],
          'icon-rotate': ['coalesce', ['get', 'mapBearing'], 0],
          'icon-rotation-alignment': 'map',
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
        },
        paint: {
          'icon-color': ['get', 'color'],
          'icon-opacity': 1,
        },
        minzoom: 5,
      },
      {
        id: 'markers-circle',
        type: 'circle',
        source: 'markers',
        paint: {
          'circle-radius': 14,
          'circle-color': '#3b82f6',
          'circle-stroke-width': 2,
          'circle-stroke-color': '#ffffff',
          'circle-opacity': 0.9,
        },
      },
      {
        id: 'markers-label',
        type: 'symbol',
        source: 'markers',
        layout: {
          'text-field': ['get', 'label'],
          'text-size': 12,
          'text-font': ['Klokantech Noto Sans Bold'],
          'text-allow-overlap': true,
          'icon-allow-overlap': true,
        },
        paint: {
          'text-color': '#ffffff',
        },
      },
    ],
  };
}
